/**
 * Bar chart. One trace per `series[]`, or a single trace from `encoding.yKey`.
 * Bar mode is the per-type layout override: grouped by default, stacked when
 * the consumer opts in via `options.stacked`.
 */

import type { ChartTypeDefinition, ChartTrace } from '../types';
import { registerChart } from '../registry';
import { makeSeriesTraces } from '../shared/traces';
import { xColumn } from '../shared/encoding';
import { colorAt } from '../theme/palette';

export const barChart: ChartTypeDefinition = {
  id: 'bar',
  label: 'Bar',
  capabilities: {
    multiSeries: true,
    supportsXKey: true,
    supportsYKey: true,
    supportsGroupBy: false,
    supportsLimits: true,
    filterable: true,
    supportsStacked: true,
    legendByDefault: false,
    supportsSecondaryYAxis: true,
    supportsDataLabels: true,
  },
  buildTraces(model, ctx) {
    const { data, encoding, series, labels, options } = model;

    if (series.length > 0) {
      return makeSeriesTraces(
        data,
        xColumn(data, encoding.xKey),
        series,
        ctx.palette,
        'bar',
        options?.showDataLabels
      );
    }
    if (encoding.yKey) {
      const trace: ChartTrace = {
        x: xColumn(data, encoding.xKey),
        y: data.map((d) => d[encoding.yKey as string]),
        name: labels.title ?? 'value',
        type: 'bar',
        marker: { color: colorAt(0, ctx.palette) },
      };
      return [trace];
    }
    return [];
  },
  buildLayout(model) {
    return { barmode: model.options?.stacked ? 'stack' : 'group' };
  },
};

registerChart(barChart);
